<template>
  <div ref="profile" class="a-color-palette">
    <ul>
      <li
        v-for="(color, index) in colors"
        :key="index"
        :style="{ width: `${color.percent * multiplier * 100}%` }"
      >
        <div
          class="a-color-palette__color-block"
          :style="{
            width: '100%',
            backgroundColor: `rgb(${color.r},${color.g},${color.b})`
          }"
          :title="`rgb(${color.r}, ${color.g}, ${color.b}) hsv(${color.h}, ${color.s}, ${color.v})`"
        ></div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "ColorPalette",
  props: {
    /**
     * An array of colors including Hue, Saturation, and Vibrance
     */
    colors: {
      type: Array,
      required: true
    }
  },
  computed: {
    /**
     * calculates the multiplier for the total percents to make the % width equal 100%
     * @returns {number}
     */
    multiplier() {
      let perc = 0;
      this.colors.forEach((color) => {
        perc += color.percent;
      });
      return 100 / (perc * 100);
    }
  }
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
